<div class="container">
  <qai-flex-container
    [direction]="'row'"
    [justifyContent]="'space-around'"
    [flexWrap]="'wrap'"
    [background]="'secondary'"
    [gap]="'30px'"
    [alignItems]="'center'"
    [border]="true"
  >
    <qai-score-weight-card
      *ngFor="let weight of weights"
      [title]="weight.section"
      [description]="'Section weight:'"
      [enabled]="!weight.disabled"
      [weight]="weight.value"
      [border]="false"
      [disabledLabel]="'Disabled'"
    ></qai-score-weight-card>
    <button
      qai-button
      [shape]="'normal'"
      [kind]="'tertiary'"
      [size]="'medium'"
      [disabled]="readOnly"
      (click)="editWeighting()"
    >
      Edit weighting
    </button>
  </qai-flex-container>
</div>
<edit-weighting-modal
  [open]="openEditModal"
  [weights]="modalWeights"
  (confirm)="handleModalConfirm($event)"
  (closeModal)="handleModalClose()"
></edit-weighting-modal>
